/* eslint-disable */
import { SVGProps } from "react";

const SvgProjectService = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="project (1)"
    xmlns="http://www.w3.org/2000/svg"
    width={52.789}
    height={40.21}
    fill="currentColor"
    viewBox="0 0 52.789 40.21"
    {...props}
  >
    <path
      data-name="Path 550"
      d="M20.105 18.558a1.547 1.547 0 1 1-1.547 1.547 1.548 1.548 0 0 1 1.547-1.547Z"
    />
    <path
      data-name="Path 551"
      d="M21.651 12.527v3.2a4.64 4.64 0 1 0 0 8.747v3.2a7.733 7.733 0 1 1 0-15.156Z"
    />
    <path
      data-name="Path 552"
      d="M9.279 20.105a10.838 10.838 0 0 0 10.826 10.826 10.719 10.719 0 0 0 1.547-.11v9.39h-4.64a1.547 1.547 0 0 1-1.547-1.547v-2.19a16.851 16.851 0 0 1-3.647-1.522l-1.556 1.557a1.546 1.546 0 0 1-2.187 0L3.7 32.134a1.548 1.548 0 0 1 0-2.187l1.558-1.557a16.771 16.771 0 0 1-1.522-3.646H1.547A1.547 1.547 0 0 1 0 23.2v-6.188a1.547 1.547 0 0 1 1.547-1.547h2.19a16.8 16.8 0 0 1 1.522-3.647L3.7 10.263a1.548 1.548 0 0 1 0-2.187L8.076 3.7a1.546 1.546 0 0 1 2.187 0l1.557 1.557a16.771 16.771 0 0 1 3.646-1.522v-2.19A1.547 1.547 0 0 1 17.012 0h4.64v9.39a10.719 10.719 0 0 0-1.547-.11A10.838 10.838 0 0 0 9.279 20.105Z"
    />
    <path
      data-name="Path 553"
      d="M43.51.905v8.374h8.374ZM29.385 9.279h6.392a1.547 1.547 0 0 1 0 3.093h-6.392a1.547 1.547 0 0 1 0-3.093Zm15.672 21.652H29.385a1.547 1.547 0 0 1 0-3.093h15.672a1.547 1.547 0 1 1 0 3.093Zm0-6.186H29.385a1.547 1.547 0 0 1 0-3.093h15.672a1.547 1.547 0 1 1 0 3.093Zm0-6.186H29.385a1.547 1.547 0 0 1 0-3.093h15.672a1.547 1.547 0 1 1 0 3.093Zm-3.093-6.186a1.547 1.547 0 0 1-1.547-1.547V0H24.745v40.21h26.5a1.547 1.547 0 0 0 1.547-1.547V12.372Z"
    />
  </svg>
);

export default SvgProjectService;
